export const removeElementFromDOM = (element) => {
    element && element.parentNode && element.parentNode.removeChild(element);
}
export const removeHeaderFooter = () => {
    removeElementFromDOM(document.getElementById("header"))
    removeElementFromDOM(document.getElementById("footer"));
    removeElementFromDOM(document.getElementById("tourContainer"));
    removeElementFromDOM(document.getElementById("secondaryNavigation"));
}